import React from 'react';

import styles from './account-password-reset-confirmation.module.scss';

const AccountPasswordResetConfirmation: React.FC<
  React.PropsWithChildren<Record<string, unknown>>
> = ({ children }) => {
  return <p className={styles.container}>{children}</p>;
};

export default AccountPasswordResetConfirmation;
